import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Heart, Moon, Orbit } from "lucide-react";
import { api } from "@/lib/apiClient";

const card = "group flex flex-col bg-[#0F1523] border border-[#D4AF37]/25 hover:border-[#D4AF37]/60 rounded-2xl p-4 transition-colors";

// Member "Explore" cards on the Signs tab.
export function ExploreSection({ sign }) {
  const s = (sign || "aries").toLowerCase();
  const items = [
    [Orbit, "Planets today", "Live positions and a daily note", "/transits", "planets"],
    [Moon, "Moon calendar", "Every New and Full Moon", "/moon-calendar", "moon"],
    [Heart, "Compatibility", `${sign || "Your sign"} with every sign`, "/compatibility", "compat"],
    [BookOpen, "Sign guides", "Personality, love, career", `/signs/${s}`, "guides"],
  ];
  return (
    <section data-testid="explore-section" className="mb-6">
      <p className="text-[11px] uppercase tracking-[0.3em] gold-text mb-2">Explore</p>
      <div className="grid grid-cols-2 gap-2">
        {items.map(([Icon, title, sub, to, id]) => (
          <Link key={id} to={to} data-testid={`explore-${id}`} className={card}>
            <Icon size={18} className="gold-text" />
            <span className="text-base mt-1.5">{title}</span>
            <span className="text-xs text-[#A7B0C0]">{sub}</span>
          </Link>
        ))}
      </div>
      <Link to="/zodiac-signs" data-testid="explore-all-guides" className="inline-block text-xs gold-text mt-2">All 12 sign guides</Link>
    </section>
  );
}

// Today: the member's own sign guide + today's Moon phase.
export function TodayExplore({ sign }) {
  const [moon, setMoon] = useState(null);
  useEffect(() => { api.get("/public/transits/moon").then(({ data }) => setMoon(data.bodies?.[0])).catch(() => {}); }, []);
  const s = (sign || "").toLowerCase();
  return (
    <div className="grid grid-cols-2 gap-2 mt-4" data-testid="today-explore">
      {s && (
        <Link to={`/signs/${s}`} data-testid="today-sign-guide" className={card}>
          <BookOpen size={18} className="gold-text" />
          <span className="text-base mt-1.5">Your {sign} guide</span>
          <span className="text-xs text-[#A7B0C0] flex items-center gap-1">Personality, love, career <ArrowRight size={11} /></span>
        </Link>
      )}
      <Link to="/moon-calendar" data-testid="today-moon-phase" className={card}>
        <Moon size={18} className="gold-text" />
        <span className="text-base mt-1.5">{moon ? moon.phase : "Moon phase"}</span>
        <span className="text-xs text-[#A7B0C0] flex items-center gap-1">{moon ? `Moon in ${moon.sign} · ${moon.illumination}% lit` : "This month's calendar"} <ArrowRight size={11} /></span>
      </Link>
    </div>
  );
}
